import { useState } from 'react';
import apiService from '../../axios/apiService';
import { message } from 'antd';

export const useCreateMonthlyCaseInvoices = () => {
  const [loading, setLoading] = useState(false);
  const createMonthlyCaseInvoices = async (data) => {
    // Create monthly case invoices
    setLoading(true);
    try {
      await apiService.createMonthlyCaseInvoices(data);
      message.success('Monthly case invoices created successfully');
    } catch (error) {
      console.log('Error: ', error);
      throw error;
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    createMonthlyCaseInvoices,
  };
};
